var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8127 5C11.8127 5.74592 11.5164 6.46129 10.989 6.98874C10.4615 7.51618 9.74615 7.8125 9.00023 7.8125C8.25431 7.8125 7.53893 7.51618 7.01149 6.98874C6.48404 6.46129 6.18773 5.74592 6.18773 5C6.18773 4.25408 6.48404 3.53871 7.01149 3.01126C7.53893 2.48382 8.25431 2.1875 9.00023 2.1875C9.74615 2.1875 10.4615 2.48382 10.989 3.01126C11.5164 3.53871 11.8127 4.25408 11.8127 5ZM3.37598 15.5885C3.40008 14.1128 4.00323 12.7056 5.05536 11.6705C6.10749 10.6354 7.52429 10.0554 9.00023 10.0554C10.4762 10.0554 11.893 10.6354 12.9451 11.6705C13.9972 12.7056 14.6004 14.1128 14.6245 15.5885C12.86 16.3976 10.9413 16.8151 9.00023 16.8125C6.99323 16.8125 5.08823 16.3745 3.37598 15.5885Z",
    fill: "#3CB98A",
    stroke: "#3CB98A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameIcon);
export default __webpack_public_path__ + "static/media/nameIcon.be735a85c3290cfd2b7060b712ccbb2e.svg";
export { ForwardRef as ReactComponent };